'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import * as ecosystemClient from '../../../clients/ecosystemClient';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIAlert from 'UIComponents/alert/UIAlert';
import DefaultReviewRenderer from 'marketplace-ui-reviews/components/DefaultReviewRenderer';
import Review from 'marketplace-ui-reviews/records/Review';
import AppReviewability from '../../../records/AppReviewability'; // Local ActionType constants

const PORTAL_REVIEWS_REQUESTED = 'PORTAL_REVIEWS_REQUESTED';
const PORTAL_REVIEWS_RECEIVED = 'PORTAL_REVIEWS_RECEIVED';
const PORTAL_REVIEWS_FAILED = 'PORTAL_REVIEWS_FAILED';
const initialState = new Immutable.Map({
  portalReviews: new Immutable.List(),
  portalReviewsFetchStatus: RequestState.UNINITIALIZED
});

const reducer = (state, action) => {
  switch (action.type) {
    case PORTAL_REVIEWS_REQUESTED:
      return state.set('portalReviewsFetchStatus', RequestState.PENDING);

    case PORTAL_REVIEWS_RECEIVED:
      return state.set('portalReviewsFetchStatus', RequestState.SUCCEEDED).set('portalReviews', action.payload);

    case PORTAL_REVIEWS_FAILED:
      return state.set('portalReviewsFetchStatus', RequestState.FAILED);

    default:
      return state;
  }
};

const ExistingPortalReviewsPanel = ({
  offeringId,
  onClose,
  reviewability
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    if (state.get('portalReviewsFetchStatus') === RequestState.UNINITIALIZED) {
      ecosystemClient.fetchReviews({
        offeringId
      }).then(resp => dispatch({
        type: PORTAL_REVIEWS_RECEIVED,
        payload: Review.fromArray(resp)
      })).catch(() => ({
        type: PORTAL_REVIEWS_FAILED
      }));
    }
  }, [offeringId, state]);
  const {
    maxPortalReviews
  } = reviewability;
  return /*#__PURE__*/_jsxs(UIModalPanel, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.detail.reviews.write.unreviewable.panel.header"
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(UIAlert, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.detail.reviews.write.unreviewable.panel.info;",
          options: {
            maxPortalReviews
          }
        })
      }), state.get('portalReviewsFetchStatus') === RequestState.SUCCEEDED && state.get('portalReviews').map(review => /*#__PURE__*/_jsx("div", {
        className: "p-bottom-6",
        style: {
          borderBottom: `2px solid ${GREAT_WHITE}`
        },
        children: /*#__PURE__*/_jsx(DefaultReviewRenderer, {
          review: review
        })
      }, review.id))]
    })]
  });
};

ExistingPortalReviewsPanel.propTypes = {
  offeringId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  reviewability: PropTypes.instanceOf(AppReviewability).isRequired
};
export default ExistingPortalReviewsPanel;